// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact {
  padding: 120px 0;
  background: linear-gradient(135deg, #e9ecef 0%, #f8f9fa 100%);
}

.contact-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 3rem;
  margin-top: 3rem;
}

.info-card {
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.info-card h3 {
  color: #2c3e50;
  margin-bottom: 2rem;
  font-size: 1.5rem;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.info-item i {
  font-size: 1.5rem;
  color: #3498db;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(52, 152, 219, 0.1);
  border-radius: 50%;
}

.info-item h4 {
  color: #2c3e50;
  margin: 0 0 0.5rem 0;
  font-size: 1.1rem;
}

.info-item a {
  color: #6c757d;
  text-decoration: none;
  transition: color 0.3s ease;
}

.info-item a:hover {
  color: #3498db;
}

.social-links {
  display: flex;
  gap: 1rem;
  margin: 1.5rem 0;
}

.social-link {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(52, 152, 219, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3498db;
  transition: all 0.3s ease;
  text-decoration: none;
}

.social-link:hover {
  background: #3498db;
  color: white;
  transform: translateY(-3px);
}

.contact-form-container {
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 1rem;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
}

.submit-button {
  background: #3498db;
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 30px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
}

.submit-button:hover {
  background: #2980b9;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(52, 152, 219, 0.3);
}

@media (max-width: 768px) {
  .contact-content {
    grid-template-columns: 1fr;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.contact-form {
  animation: fadeIn 0.8s ease-out;
}

.success-message {
  background-color: #d4edda;
  color: #155724;
  padding: 1rem;
  border-radius: 10px;
  margin-bottom: 1rem;
  text-align: center;
}

.error-message {
  background-color: #f8d7da;
  color: #721c24;
  padding: 1rem;
  border-radius: 10px;
  margin-bottom: 1rem;
  text-align: center;
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
} `, "",{"version":3,"sources":["webpack://./src/components/Contact/Contact.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".contact {\n  padding: 120px 0;\n  background: linear-gradient(135deg, #e9ecef 0%, #f8f9fa 100%);\n}\n\n.contact-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.contact-content {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 3rem;\n  margin-top: 3rem;\n}\n\n.info-card {\n  background: white;\n  padding: 2rem;\n  border-radius: 20px;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n}\n\n.info-card h3 {\n  color: #2c3e50;\n  margin-bottom: 2rem;\n  font-size: 1.5rem;\n}\n\n.info-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.info-item i {\n  font-size: 1.5rem;\n  color: #3498db;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(52, 152, 219, 0.1);\n  border-radius: 50%;\n}\n\n.info-item h4 {\n  color: #2c3e50;\n  margin: 0 0 0.5rem 0;\n  font-size: 1.1rem;\n}\n\n.info-item a {\n  color: #6c757d;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.info-item a:hover {\n  color: #3498db;\n}\n\n.social-links {\n  display: flex;\n  gap: 1rem;\n  margin: 1.5rem 0;\n}\n\n.social-link {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(52, 152, 219, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #3498db;\n  transition: all 0.3s ease;\n  text-decoration: none;\n}\n\n.social-link:hover {\n  background: #3498db;\n  color: white;\n  transform: translateY(-3px);\n}\n\n.contact-form-container {\n  background: white;\n  padding: 2rem;\n  border-radius: 20px;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 1rem;\n  border: 2px solid #e9ecef;\n  border-radius: 10px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #3498db;\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);\n}\n\n.submit-button {\n  background: #3498db;\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 30px;\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: 100%;\n}\n\n.submit-button:hover {\n  background: #2980b9;\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(52, 152, 219, 0.3);\n}\n\n@media (max-width: 768px) {\n  .contact-content {\n    grid-template-columns: 1fr;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.contact-form {\n  animation: fadeIn 0.8s ease-out;\n}\n\n.success-message {\n  background-color: #d4edda;\n  color: #155724;\n  padding: 1rem;\n  border-radius: 10px;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n.error-message {\n  background-color: #f8d7da;\n  color: #721c24;\n  padding: 1rem;\n  border-radius: 10px;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n.submit-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
